import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { CommonService } from './common.service';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../auth/_services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ErrorLogService extends CommonService {
  sortField:string='';
  sortOrder:string='';
  constructor(http: HttpClient, private authService: AuthService, private toastr: ToastrService) {
    super('ErrorLog',http);
  }
  
  getErrorLogList(){
    return this.http.get(environment.baseURL+'ErrorLog/GetErrorLog').pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        if (err.status == '401' || err.status == '500') {
          this.authService.logout();
          this.toastr.error("your session has been expired please login again", 'Error!');
        }
        return null;
      })
    );
  }

  updateErrorLogStatus(obj){      
    return this.http.put(environment.baseURL+'ErrorLog/UpdateErrorLogStatus?Id='+obj.id, obj).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        if (err.status == '401' || err.status == '500') {
          this.authService.logout();
          this.toastr.error("your session has been expired please login again", 'Error!');  
        }
        return null;
      })
    );
  }

  updateErrorLogDescription(obj){      
    return this.http.put(environment.baseURL+'ErrorLog/UpdateErrorLogDescription?Id='+obj.id, obj).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        if (err.status == '401' || err.status == '500') {
          this.authService.logout();
          this.toastr.error("your session has been expired please login again", 'Error!');  
        }
        return null;
      })
    );
  }

}